module.exports = __webpack_public_path__ + "media/social/link-youtube@2x-e972de74.png";